<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <!--
    <Route
      v-if="hasRole('>=MANAGER')"
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="SectionTemplatesAdd">
      <Icon name="plus" /> {{ $t('button') }}
    </Route>
    -->
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column v-for="sectionTemplate in results" :key="sectionTemplate.id" :xl="6">
          <RecordSectionTemplate :sectionTemplate="sectionTemplate" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordSectionTemplate from './components/RecordSectionTemplate'
import Table from '@mixins/Table'
import { actions } from '@utils'
import { pluckId } from '@utils/collections'

export default {
  mixins: [Table],
  components: { RecordSectionTemplate },
  data() {
    return {
      paginationOptions: {
        name: 'sectionTemplate',
        service: 'sectionTemplate',
      },
    }
  },
  methods: {
    ...actions(
      'FETCH_PROMPT',
    ),
  },
  watch: {
    async results(sectionTemplates) {
      if (!sectionTemplates.length) return

      const promptIds = pluckId('promptId', sectionTemplates)

      if (!promptIds.length) return

      await this.LOAD(() =>
        this.FETCH_PROMPT({
          id: { $in: promptIds },
        }))
    },
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "SectionTemplates",
    "button": "Add a sectionTemplate"
  }
}
</i18n>
